import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter-stars"
// Renders 1-5 clickable star buttons for a min-rating filter.
// Clicking a star updates the hidden input value only — form submission
// is left to the explicit "Show me" / "Apply Filters" button.
// Clicking the same active star again clears the selection.
export default class extends Controller {
  static values = { current: Number }
  static targets = ["star", "input", "label"]

  connect() {
    this.render(this.currentValue)
  }

  select(event) {
    const clicked = parseInt(event.currentTarget.dataset.value)
    // Toggle off if the same star is clicked again
    const next = this.currentValue === clicked ? 0 : clicked
    this.currentValue = next
    this.inputTarget.value = next > 0 ? next : ""
    this.render(next)
  }

  highlight(event) {
    const hovered = parseInt(event.currentTarget.dataset.value)
    this.paint(hovered)
  }

  reset() {
    this.render(this.currentValue)
  }

  render(value) {
    this.paint(value)
    if (this.hasLabelTarget) {
      this.labelTarget.classList.toggle("hidden", value > 0)
    }
  }

  paint(activeVal) {
    this.starTargets.forEach(star => {
      const v = parseInt(star.dataset.value)
      star.classList.toggle("text-primary-400", v <= activeVal)
      star.classList.toggle("text-gray-700", v > activeVal)
    })
  }
}
